import EditorNewsletterPicker from './editor-newsletter-picker';

export default EditorNewsletterPicker;
